import { __rest } from "tslib";
import { writable, derived } from 'svelte/store';
import config from './config';
export const mapStore = writable(null);
// the layers that are currently open
// FIXME types
export const layersStore = writable({});
// FIXME types on that any. For now, this is ok as the store can actually store anything
const STORE_MAP = {};
/**
 * We will create one store per control. This store will be cached, as
 * there is no easy way to remove a svelte store (TODO: more research on this)
 *
 * FIXME use generics
 */
export const GetOrCreateControlStore = (id, initialValue) => {
    if (id in STORE_MAP) {
        return STORE_MAP[id];
    }
    const store = writable(initialValue);
    STORE_MAP[id] = store;
    return store;
};
export const popupFeatureStore = writable([]);
export const popupLatlngStore = writable({});
export const mouseOverLayerId = writable('');
export function setupMapStateStore(initialState) {
    const { subscribe, set, update } = writable(initialState);
    const updateStoreValues = (controlPropertyValues) => {
        controlPropertyValues.forEach(item => {
            var _a;
            (_a = item.controlProperties) === null || _a === void 0 ? void 0 : _a.forEach(c => {
                const id = `${item.layerId}.${c.controlPropertyId}`;
                const store = GetOrCreateControlStore(id, c.value);
                store.set(c.value);
            });
        });
    };
    const _set = (mapState) => {
        if ((mapState === null || mapState === void 0 ? void 0 : mapState.controlPropertyValues) != null) {
            updateStoreValues(mapState.controlPropertyValues);
        }
        // when setting the mapState, if we don't have layers set explicity,
        // then use the layers that already exist
        update(m => { var _a; return Object.assign(Object.assign({}, mapState), { layers: (_a = mapState === null || mapState === void 0 ? void 0 : mapState.layers) !== null && _a !== void 0 ? _a : m.layers }); });
    };
    return {
        subscribe,
        update,
        set: _set,
        addLayer: (layerId) => update(s => {
            if (s.layers == null)
                return Object.assign(Object.assign({}, s), { layers: [layerId] });
            return Object.assign(Object.assign({}, s), { layers: [...s.layers, layerId] });
        }),
        addLayers: (layerIds) => update(s => {
            if (s.layers == null)
                return Object.assign(Object.assign({}, s), { layers: layerIds });
            return Object.assign(Object.assign({}, s), { layers: [...s.layers, ...layerIds] });
        }),
        removeLayer: (layerId) => update(s => {
            // FIXME do we want to make this null if removing means an empty list?
            if (s.layers == null)
                return Object.assign(Object.assign({}, s), { layers: [layerId] });
            return Object.assign(Object.assign({}, s), { layers: s.layers.filter(x => x != layerId) });
        }),
        setControlProperties: (controlPropertyValues) => {
            updateStoreValues(controlPropertyValues);
            update(m => { return Object.assign(Object.assign({}, m), { controlPropertyValues }); });
        },
        reset: () => set(initialState),
    };
}
export const mapStateStore = setupMapStateStore(config.initialMapState);
/*
 * A store to map layerId's to a mapping of style functions,
 * this way we can do things like change opacity separately from other features
 */
function setupStyleStore() {
    const _store = writable({});
    const _derived = derived([_store], ([$store]) => {
        return $store;
    });
    /*
     *    The updateFunc adds a style func to a mapping of functions by name.
     *    The functions are then combined with a reduce function to make a full
     *    onStyle. The opacity function is run last, as other functions may override opacity.
     *    For any function that sets opacity, the regular opacity function will multiply to
     *    preserve the relative opacity of other functions
     */
    const updateStyleFunc = (layerId, funcName, styleFunc) => _store.update((m) => {
        if (!(layerId in m) || !('onStyle' in m[layerId])) {
            return Object.assign(Object.assign({}, m), { [layerId]: { [funcName]: styleFunc, onStyle: styleFunc } });
        }
        else {
            // remove the old onStyle function. we will replace this function later
            const _a = m[layerId], { onStyle } = _a, mFuncs = __rest(_a, ["onStyle"]);
            const mFuncsNew = Object.assign(Object.assign({}, mFuncs), { [funcName]: styleFunc });
            // recreate the onStyle func here
            const _onStyle = (feature) => {
                // run all funcs from the mappings, but split out opacity to run later
                const { opacity } = mFuncsNew, funcs = __rest(mFuncsNew, ["opacity"]);
                let value = Object.entries(funcs).reduce((result, [_, func]) => {
                    return Object.assign(Object.assign({}, result), func(feature));
                }, {});
                // handle the opacity last, and use it as a multiplying factor
                if (opacity != null) {
                    const opacityValues = opacity(feature);
                    // if we get a nan or a null, handle it cleanly assuming that it is not set
                    const fillOpacityValue = isNaN(value === null || value === void 0 ? void 0 : value.fillOpacity) || (value === null || value === void 0 ? void 0 : value.fillOpacity) == null ? 1 : value === null || value === void 0 ? void 0 : value.fillOpacity;
                    const opacityValue = isNaN(value === null || value === void 0 ? void 0 : value.opacity) || (value === null || value === void 0 ? void 0 : value.opacity) == null ? 1 : value === null || value === void 0 ? void 0 : value.opacity;
                    value = Object.assign(Object.assign({}, value), { opacity: opacityValues.opacity * opacityValue, fillOpacity: opacityValues.fillOpacity * fillOpacityValue });
                }
                return value;
            };
            return Object.assign(Object.assign({}, m), { [layerId]: Object.assign(Object.assign({}, mFuncsNew), { onStyle: _onStyle }) });
        }
    });
    return {
        subscribe: _derived.subscribe,
        update: _store.update,
        set: _store.set,
        updateStyleFunc
    };
}
export const styleFuncStore = setupStyleStore();
